<!-- HxCascadingSearch Component using HxDropdown with Path Navigation -->
<hx-dropdown
  #dropdown
  [options]="dropdownOptions()"
  [placeholder]="placeholder()"
  [customDisplayText]="displayValue()"
  [customDisplaySubtitle]="displaySubtitle()"
  [searchable]="searchable()"
  [disabled]="disabled() || disabledState()"
  [class]="'hx-cascading-search ' + (class() || '')"
  (valueChange)="onOptionSelected($event)"
  (searchChange)="onSearchChange($event)"
  (opened)="onDropdownOpened()"
  (closed)="onDropdownClosed()"></hx-dropdown>
